import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=172a01b6&"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrder.vue?vue&type=style&index=0&id=172a01b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports